// src/utils/formatLength.ts
export const formatLength = (lengthInSeconds) => {
  const minutes = Math.floor(lengthInSeconds / 60);
  const seconds = Math.floor(lengthInSeconds % 60);
  return minutes > 0 ? `${minutes}' ${seconds}"` : `${seconds}"`;
};
